import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

export const useDeleteStandings = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { sport, organizationId, seasonId } = useParams();

  return useMutation<DefaultOperationSuccessResponse, Error>({
    mutationFn: async () => {
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/standings?forceDelete=true`, {
        method: "DELETE",
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (isDefaultOperationSucceeded(response)) {
        await queryClient.invalidateQueries({
          queryKey: ["standings", sport, organizationId, seasonId],
        });
      }
    },
  });
};
